'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DocsTable(props) {
  var columns = props.columns,
      schema = props.schema,
      addQueryField = props.addQueryField;
  var docs = props.docs;
  var noWrapObj = props.noWrapObj,
      toggleWrap = props.toggleWrap,
      onMouseDown = props.onMouseDown,
      _onMouseUp = props.onMouseUp;
  var _props$page = props.page,
      gotoCreateDoc = _props$page.gotoCreateDoc,
      view = _props$page.view;
  var style = props.style;


  var noResult = docs.length === 0;

  return _react2.default.createElement(
    'table',
    { className: 'table table-hover ' + style.table },
    _react2.default.createElement(
      'thead',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'th',
          { className: style.editButtonCell, style: { width: 40 } },
          '\xA0'
        ),
        _react2.default.createElement(
          'th',
          { className: style.editButtonCell, style: { width: 40 } },
          _react2.default.createElement('i', {
            className: 'fa fa-lg fa-plus-square ' + style.createButton,
            onClick: gotoCreateDoc
          })
        ),
        columns.map(function (_ref) {
          var key = _ref.key,
              width = _ref.width,
              name = _ref.name;
          return _react2.default.createElement(
            'th',
            { key: key, style: { width: width || 100 } },
            _react2.default.createElement(
              'div',
              { className: style.title, onClick: function onClick() {
                  return Array.isArray(key) ? addQueryField(key.join('.')) : addQueryField(key);
                } },
              name || (Array.isArray(key) ? _ramda2.default.path(_ramda2.default.intersperse('contents', key).concat('name'), schema.contents) : schema.contents[key].name)
            )
          );
        })
      )
    ),
    _react2.default.createElement(
      'tbody',
      null,
      noResult ? _react2.default.createElement(
        'tr',
        { className: style.noResult },
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            null,
            '\u6C92\u6709\u9805\u76EE\u6216\u641C\u5C0B\u4E0D\u5230\u7D50\u679C\uFF0C\u8ACB\u91CD\u65B0\u641C\u5C0B\u6216',
            _react2.default.createElement(
              'span',
              { className: style.add, onClick: gotoCreateDoc },
              '\u65B0\u589E\u9805\u76EE'
            )
          )
        )
      ) : null,
      docs.map(function (doc) {
        return _react2.default.createElement(
          'tr',
          {
            key: doc._id,
            className: noWrapObj[doc._id] ? style.showMore : null,
            onMouseDown: onMouseDown,
            onMouseUp: function onMouseUp(e) {
              return _onMouseUp(e)(doc._id);
            }
          },
          _react2.default.createElement(
            'td',
            {
              className: style.editButtonCell, style: { width: 40 },
              onMouseUp: function onMouseUp(e) {
                return e.stopPropagation();
              }
            },
            _react2.default.createElement(
              'a',
              { href: '/#/edit/' + view + '/' + doc._id, target: '_blank' },
              _react2.default.createElement(
                'div',
                { className: style.buttonWrapper },
                _react2.default.createElement('i', {
                  className: 'fa fa-lg fa-copy ' + style.button,
                  'aria-hidden': 'true'
                })
              )
            )
          ),
          _react2.default.createElement(
            'td',
            { className: style.editButtonCell, style: { width: 40 } },
            _react2.default.createElement(
              'div',
              {
                className: style.buttonWrapper,
                onClick: function onClick() {
                  return toggleWrap(doc._id);
                },
                onMouseUp: function onMouseUp(e) {
                  return e.stopPropagation();
                }
              },
              _react2.default.createElement('i', {
                className: 'fa fa-lg fa-arrows-v ' + style.button,
                'aria-hidden': 'true'
              })
            )
          ),
          columns.map(function (_ref2) {
            var key = _ref2.key,
                width = _ref2.width,
                formatter = _ref2.formatter;
            return _react2.default.createElement(
              'td',
              { style: { width: width || 100 }, key: key },
              formatter(Array.isArray(key) ? _ramda2.default.path(key, doc) : doc[key])
            );
          })
        );
      })
    )
  );
}

DocsTable.propTypes = {
  columns: _propTypes.array.isRequired,
  schema: _propTypes.object.isRequired,
  style: _propTypes.object.isRequired,

  docs: _propTypes.array.isRequired,
  noWrapObj: _propTypes.object.isRequired,
  toggleWrap: _propTypes.func.isRequired,

  page: (0, _propTypes.shape)({
    gotoCreateDoc: _propTypes.func.isRequired
  }).isRequired,
  addQueryField: _propTypes.func.isRequired,

  onMouseUp: _propTypes.func.isRequired,
  onMouseDown: _propTypes.func.isRequired
};

exports.default = DocsTable;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/DocsTable/DocsTable.js
// module id = 1754
// module chunks = 0